const EXTENSION_ID = 'fnnkoekkeploiebcajecebliihebbmok'

export const init = async () => {
  let response: string
  try {
    response = await chrome.runtime.sendMessage(EXTENSION_ID, 'check-presence')
  } catch {
    return
  }
  if (response !== 'present') {
    return
  }

  const OriginalWebSocket = window.WebSocket
  const logMessage = (
    direction: 'out' | 'in',
    connectionId: string,
    message: string | ArrayBuffer | Blob | ArrayBufferView
  ) => {
    const now = new Date().toISOString()
    chrome.runtime.sendMessage(EXTENSION_ID, { direction, message, timestamp: now, connectionId })
  }

  // @ts-ignore - we need to modify the prototype because `@xmpp/client` assigns `global.WebSocket` to another variable meaning that a simple reassignment won't work
  OriginalWebSocket.prototype._getId = function () {
    // @ts-ignore
    if (!this._id) {
      // @ts-ignore
      this._id = Math.random().toString(36).slice(2)
      this.addEventListener('message', function (event) {
        // @ts-ignore
        logMessage('in', this._id, event.data)
      })
    }
    // @ts-ignore
    return this._id
  }

  const originalSend = OriginalWebSocket.prototype.send
  OriginalWebSocket.prototype.send = function (
    data: string | ArrayBuffer | Blob | ArrayBufferView
  ) {
    // @ts-ignore
    logMessage('out', this._getId(), data)
    return originalSend.apply(this, [data])
  }
}
